import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';

function App() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Calculate an opacity that goes from 0 to 1 over the first 800px of scrolling
  const overlayOpacity = Math.min(scrollY / 800, 1);

  return (
    <div className="app-container">
      <Navbar />
      
      {/* Animated Background Orbs */}
      <div className="background-wrapper">
        <div className="glow-orb cyan"></div>
        <div className="glow-orb purple"></div>
        {/* Dynamic Dark Gradient Overlay */}
        <div 
          className="background-scroll-overlay"
          style={{ opacity: overlayOpacity }}
        ></div>
      </div>

      <main>
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Projects />
        <Contact />
      </main>
    </div>
  );
}

export default App;
